import { render, staticRenderFns } from "./VRLargeProductCard.vue?vue&type=template&id=55779300"
import script from "./VRLargeProductCard.vue?vue&type=script&lang=js"
export * from "./VRLargeProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports